export enum EntityTypes {
  UNKNOWN = 'UNKNOWN',

  ACTION = 'ACT',
  ACTION_ENTITY = 'ACTENT',
  ACTION_AUDIO = 'ACTAUD',
  ACTION_TEMPLATE = 'ACTTEMP',
  ACTIVITY = 'ACTV',
  ANIMATION = 'ANI',
  AUDIO = 'AUD',
  AUDIO_FILE = 'AUDFIL',
  CALENDAR = 'CAL',
  CERTIFICATE = 'CERT',
  CERTIFICATE_PERMISSION = 'CERTPERM',
  COURSE = 'COU',
  COURSE_OUT = 'COUOUT',
  COURSE_NODE = 'COUNOD',
  COURSE_NODE_ENTITY = 'COUNODENT',
  COURSE_NODE_GROUP = 'COUNODGRO',
  COURSE_GROUP_INSTANCE = 'CGROINST',
  COURSE_PERMISSION = 'COUPERM',
  COURSE_PROGRESS = 'COUPROG',
  COURSE_VARIABLE = 'COUVAR',
  COURSE_USER_VARIABLE = 'COUUSVAR',
  DOMAIN = 'DOM',
  DOMAIN_CONFIG = 'DOMCONFIG',
  EMAIL = 'EMAIL',
  FOLDER = 'FOLD',
  FOLDER_PERMISSION = 'FOLDPERM',
  FORUM_POST = 'FORPOST',
  FORUM_POST_MENTION = 'FORPOSTMTN',
  FORUM_POST_VIEW = 'FORPOSTVW',
  FORUM_TOPIC = 'FORTOP',
  FORUM_PERMISSION = 'FORPERM',
  GROUP = 'GRO',
  GROUP_ACCESS_PERMISSION = 'GROACCPERM',
  GROUP_PERMISSION = 'GROPERM',
  GROUP_REPORT = 'GRORPT',
  GROUP_USER = 'GROUSR',
  IMAGE = 'IMG',
  IMAGE_FILE = 'IMGFLE',
  LANG = 'LANG',
  MEDIA_ASSET = 'MEDASS',
  MEDIA_SYSTEM = 'MEDSYS',
  MODEL = 'MDL',
  MODEL_ENTITY = 'MDLENT',
  MODEL_ENTITY_CONFIG = 'MDLENTCON',
  MODEL_FILE = 'MDLFLE',
  MODULE = 'MOD',
  MODULE_OUT = 'MOUT',
  MODULE_PERMISSION = 'MODPERM',
  MODULE_VERSION = 'MVER',
  MODULE_VARIABLE = 'MVAR',
  NODE = 'NODE',
  NOTIFICATION = 'NOT',
  ORGANISATION = 'ORG',
  ORG_CONFIG = 'ORGCON',
  ORG_TAG = 'ORGTAG',
  ORG_USER = 'ORGUSR',
  ORG_USER_CERTIFICATE = 'ORGUSRCER',
  ORG_USER_COURSE = 'ORGUSRCOU',
  ORG_USER_STATE = 'ORGUSRSTA',
  ORG_USER_VARIABLE = 'ORGUSRVAR',
  ORG_USER_VARIABLE_OVER = 'ORGUSRVAROVER',
  ORG_USER_VERIFICATION = 'ORGUSRVER',
  ORG_USER_VERIFICATION_ENTITY = 'ORGUSRVERENT',
  ORG_USER_VERIFICATION_ENTITY_MEDIA = 'ORGUSRVERENTMED',
  ORG_SYSTEM = 'ORGSYS',
  ORG_SYSTEM_VALUE = 'ORGSYSVAL',
  OVERRIDE = 'OVER',
  PERMISSION = 'PERM',
  PORTRAIT_VARIANT = 'PORVAR',
  POSITION = 'POS',
  ROLE_CONFIG = 'ROLCON',
  ROTATION = 'ROT',
  SCENE = 'SCE',
  SCENE_CONFIG = 'SCECON',
  SEARCH = 'SEA',
  SEARCH_RESULT = 'SEARES',
  SERVICE = 'SER',
  SERVICE_ATTRIBUTE = 'SERVATTR',
  SESSION = 'SES',
  SESSION_ATTEMPT = 'SESATT',
  SESSION_ACTION = 'SESACT',
  SESSION_ACTION_ENTITY = 'SESACTENT',
  SESSION_RESOURCE = 'SESRES',
  SESSION_VARIABLE = 'SESVAR',
  SESSION_ACTION_MEDIA = 'SESACTMED',
  STRUCTURE = 'STR',
  STRUCTURE_GROUP_INSTANCE = 'STUGROINST',
  STRUCTURE_OUT = 'STUGROUOUT',
  STRUCTURE_PERMISSION = 'STRPERM',
  SYSTEM = 'SYS',
  SYSTEM_GROUP = 'SYSGRO',
  SYSTEM_USER = 'SYSUSR',
  SYSTEM_ATTRIBUTE = 'SYSATTR',
  SYSTEM_SERVICE = 'SYSSER',
  TAG = 'TAG',
  TAG_JOIN = 'TAGJOI',
  TEXT = 'TEXT',
  TEMPLATE = 'TEM',
  THEME = 'THM',
  // Certificate and email templates (Settings → Templates). TEMPLATE above is a legacy code.
  DESIGN_TEMPLATE = 'DSGNTPL',
  TOKEN = 'TOKEN',
  TRANSCRIPTION = 'TNS',
  TRANSCRIPTION_ITEM = 'TNSITM',
  TRANSLATION = 'TNL',
  USER = 'USR',
  USER_IMPORT = 'USRIMP',
  VARIABLE = 'VAR',
  VARIABLE_OPTION = 'VAROPT',
  VERIFICATION = 'VER',
  VERIFICATION_ENTITY = 'VERENT',
  VERIFICATION_REQUEST = 'VERREQ',
  VERIFICATION_REQUEST_ENTITY = 'VERREQENT',
  VERIFICATION_RESPONSE = 'VERRES',
  VIDEO = 'VID',
  VIDEO_FILE = 'VIDFLE',
  VIDEO_GROUP = 'VIDGRO',
  VIDEO_TEMPLATE = 'VIDTMP',
}

export type Node = {
  x: number;
  y: number;
};

export type Position = {
  x: number;
  y: number;
  z: number;
  w: number;
};

export type Rotation = {
  x: number;
  y: number;
  z: number;
  w: number;
};
